var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-view',{style:(("padding-left: " + (_vm.drawer ? 260 : 20) + "px; overflow-y: auto; padding:right: 20px; margin-right: 0px"))},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }